import React from 'react';

import useStyles from './ProcessBox.style';

export interface ProcessBoxProps {
  type?: 'first' | 'last' | 'default'
  testId?: string
}

const ProcessBox: React.FC<ProcessBoxProps> = ({ children, testId, type = 'default'}) => {
  const c = useStyles({ });

  const setClassName = () => {
    if (type === 'first') {
      return c.processBoxFirst;
    }
    if (type === 'last') {
      return c.processBoxLast;
    }
    return c.processBox;
  };

  return (
    <div
      data-testid={testId}
      className={setClassName()}
    >
      {children}
    </div>
  );
};

export { ProcessBox };
